import { Suspense, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import BgFooter from '@/assets/images/bg-footer.png';
import BgFooterLight from '@/assets/images/bg-footer-light.png';
import ThemeToggle from '@/components/Helper/ThemeToggle';
import { useTheme } from 'next-themes';
import { useMounted } from '@/hooks/mounted.hook';

export default function AuthLayout() {
  const mounted = useMounted();
  const { resolvedTheme } = useTheme();
  const [backgroundImage, setBackgroundImage] = useState<string>('');

  useEffect(() => {
    if (mounted && resolvedTheme) {
      setBackgroundImage(resolvedTheme === 'dark' ? BgFooter : BgFooterLight);
    }
  }, [resolvedTheme, mounted]);

  if (!mounted) {
    return null;
  }

  return (
    <div className="min-h-screen flex flex-col bg-no-repeat bg-[#F6F6F6] dark:bg-[#1C1C1E]">
      {/* Content */}
      <div className="ml-auto p-5">
        <ThemeToggle size={25} />
      </div>
      <main
        className={`flex-1 flex justify-center px-4 lg:pb-16 lg:pt-40 ${resolvedTheme === 'dark' ? 'bg-[#1C1C1E]' : 'bg-[#F6F6F6]'
          }`}
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center bottom',
          backgroundSize: '100% 50%',
        }}
      >
        <Suspense fallback={null}>
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
}
